import { Popover } from 'antd';
import AC from '../AccessControl';
import PopoverContent from './PopoverContent';
import styles from './ListView.module.scss';
const ListDisplay = ({
  listData
}) => <ol data-sentry-component="ListDisplay" data-sentry-source-file="ListView.jsx">
  {listData.map(datum => datum.type === 'group' ? <li key={datum.key}>
        <span className={styles['group-label']}>{datum.name}</span>
        <ListDisplay listData={datum.children} />
      </li> : <li className={styles['list-item-link']} key={datum.key}>
        <Popover content={<PopoverContent data={datum} />} style={{
      maxWidth: 330
    }} title={datum.linkName}>
          {/* Fragment needed for Popover to work, reason unknown */}
          <>
            <AC.Link href={{
          pathname: `/toolkits/${datum.type}/[slug]`,
          query: {
            slug: datum.slug
          }
        }} label={datum.linkName || datum.name} ifCant={datum.linkName || datum.name} />
          </>
        </Popover>
      </li>)}
  </ol>;
const ListView = ({
  contentData
}) => <div className={styles['list-view-container']} data-sentry-component="ListView" data-sentry-source-file="ListView.jsx">
    {contentData && <ListDisplay listData={contentData} />}
  </div>;
export default ListView;